import React, { useRef, useEffect,useContext } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { downloadPdfReport } from "../../../../service/StudyReportService";
import { t } from "i18next";
import { ADVANCE_VIEWER_MODALITIES, NONXRAYMODALITIES, VDCLIMS } from "../../../../constants/Constants";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import { getPaymentStatusOfStudy } from "../../../../service/StudyListService";
import { useState } from "react";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";

const DownloadOptions = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const {enableLlmReport} = useContext(userContext);
  const ref = useRef(null);
  const { onClickOutside } = props;

  const currentUrl = window.location.href;
  const containsStudyList = currentUrl.includes('studylist');

  const {
    downloadReport
  } = useContext(studyReportContext);

  const [paymentStatusOfStudy, setPaymentStatusOfStudy] = useState(0);
  const [paymentMessageOfStudy, setPaymentMessageOfStudy] = useState("");
  const [showPaymentAlertModal, setShowPaymentAlertModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const aiReportOptions = props.aiReportOptions != null && props.aiReportOptions != undefined ? props.aiReportOptions : false
  const reportOptions = props.reportOptions != null && props.reportOptions != undefined ? props.reportOptions : true
  const peerReviewReportOptions = props.peerReviewReportOptions != null && props.peerReviewReportOptions != undefined ? props.peerReviewReportOptions : false;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowPaymentAlertModal(false);
        setShowConfirmModal(false);
        setPaymentMessageOfStudy("");
        setPaymentStatusOfStudy(0);
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const handleDownloadReport = async(type, studyId) =>{
    downloadReport(type, studyId);

  }

  const handlePaymentAlertModal = () =>{
    setShowPaymentAlertModal(false);
    setShowConfirmModal(false);
    setPaymentMessageOfStudy("");
    setPaymentStatusOfStudy(0);
  }

  const handleDownloadOptions = (type, isExtReportReceived) =>{
    if(!isExtReportReceived){
      if(type != "pdfwithimage"){
        return true;
      }
      else if(type == "pdfwithimage" && props.modality != null && props.modality != undefined && !ADVANCE_VIEWER_MODALITIES.includes(props.modality)){
         return true;
      }
    } else if(isExtReportReceived && type == "pdf" && props.modality != null && props.modality != undefined && NONXRAYMODALITIES.includes(props.modality)){
      return true;
    } else if(isExtReportReceived && type == "pdfwithkeyimage" && props.modality != null && props.modality != undefined && !NONXRAYMODALITIES.includes(props.modality)){
      return true;
    }
    return false;
  }

  return (
    <div ref={ref} className={props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true?"download-options-study-list":"download-options"} style={{backgroundColor: getThemeColor("action-details-background"), top:`${enableLlmReport? '32px':''}`, bottom:`${enableLlmReport?'':'32px'}`}}>
      {showPaymentAlertModal &&
        <ConfirmModal handleConfirm={handlePaymentAlertModal} handleNotConfirm={handlePaymentAlertModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={paymentMessageOfStudy}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")} cancelButtonText={t("confirm-message.cancel")}/>
      }
      <ul className="dropdown-menu-react" style={{color: getThemeColor("primary-color")}}>
      {aiReportOptions && <li>
          <a  style={{color: getThemeColor("primary-color")}} id="ai-report" onClick={()=>{props.downloadAIReport(props.studyParentId)}}>
            {t("heading.download-ai-report")}
          </a>
        </li>}

        {process.env.REACT_APP_VDC_PLATFORM == "false" && (
    <>
      {reportOptions && handleDownloadOptions("docx", props.isExtReportReceived) && (
        <li>
          <a id="docx" onClick={() => { handleDownloadReport("docx", props.studyParentId) }}>
            {t("hospital.docx")}
          </a>
        </li>
          )}
        
      {reportOptions && handleDownloadOptions("docxwithkeyimage", props.isExtReportReceived) && (
        <li>
          <a
            id="docxwithkeyimage"
            onClick={() => { handleDownloadReport("docxwithkeyimage", props.studyParentId) }}
            style={{
              fontWeight: `${props.isKeyImagesPresent ? "bold" : ""}`
            }}
          >
            {t("hospital.docx-key-image")}
          </a>
        </li>
      )}
      {reportOptions && handleDownloadOptions("doc", props.isExtReportReceived) && (
        <li>
          <a id="doc" onClick={() => { handleDownloadReport("doc", props.studyParentId) }}>
            {t("hospital.doc")}
          </a>
        </li>
      )}
  </>
  )}
        {reportOptions && handleDownloadOptions("pdf",props.isExtReportReceived) && <li>
          <a id="pdf" onClick={()=>{handleDownloadReport("pdf",props.studyParentId)}}>
          {t("hospital.pdf")}
          </a>
        </li>}
        {reportOptions && handleDownloadOptions("pdfwithimage",props.isExtReportReceived) && <li>
          <a id="pdfwithimage" onClick={()=>{handleDownloadReport("pdfwithimage",props.studyParentId)}}>
          {t("hospital.pdf-image")}
          </a>
        </li>}
        {reportOptions && handleDownloadOptions("pdfwithkeyimage",props.isExtReportReceived) && <li>
          <a
            id="pdfwithkeyimage"
            onClick={()=>{handleDownloadReport("pdfwithkeyimage",props.studyParentId)}}
            style={{
              fontWeight: `${props.isKeyImagesPresent ? "bold" : ""}`
            }}
          >
           {t("hospital.pdf-key-image")}
          </a>
        </li>}
        {peerReviewReportOptions && handleDownloadOptions("peerReview",props.isExtReportReceived) && <li>
          <a id="pdf" onClick={()=>{handleDownloadReport("peerReview",props.studyParentId)}}>
          {t("hospital.peer-review")}
          </a>
        </li>}
      </ul>
    </div>
  );
};

export default DownloadOptions;


 {/* <Dialog
        hidden={hideDialog}
        onDismiss={setToggleHideDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          <PrimaryButton onClick={setToggleHideDialog} text="Send" />
          <DefaultButton onClick={setToggleHideDialog} text="Don't send" />
        </DialogFooter>
      </Dialog> */}

    // const dragOptions = {
  //   moveMenuItemText: 'Move',
  //   closeMenuItemText: 'Close',
  //   menu: ContextualMenu,
  // };
  // const dialogContentProps = {
  //   type: DialogType.normal,
  //   title: 'Missing Subject',
  //   subText: 'Do you want to send this message without a subject?',
  // };

  // const modalPropsStyles = { main: { maxWidth: 450 } };

  // const modalProps = 
  //   () => ({
  //     isBlocking: true,
  //     styles: modalPropsStyles,
  //     dragOptions: isDraggable ? dragOptions : undefined,
  //   });
